export function addObservedAttributes(target, attributeName): void {
  const observedAttributes = [attributeName].concat(target.constructor['observedAttributes'] || []);
  Object.defineProperty(target.constructor, 'observedAttributes', {
    configurable: true,
    get(): any {
      return observedAttributes;
    },
  });
}
